<template>
  <div class="pm-dialog-port-vessel">
    <vs-row vs-w="12" style="height: 5rem">
      <vs-col class="w-full">
        <vs-row style="height: 50%">
          <vs-col vs-w="12" class="flex items-center">
            <div class="th">
              <span v-if="!valueMap.order_type || valueMap.order_type != '4'"
                >船舶名</span
              >
              <span v-else>タスク</span>
            </div>
            <div class="td">
              <div v-if="!valueMap.order_type || valueMap.order_type != '4'">
                <span
                  style="
                    font-weight: bolder;
                    font-size: larger;
                    margin-right: 1rem;
                  "
                  >{{
                    !valueMap.enterprisePortVessel
                      ? "-"
                      : valueMap.enterprisePortVessel.label ||
                        valueMap.enterprisePortVessel.name ||
                        "-"
                  }}</span
                >
                <span style="font-weight: bolder; font-size: larger">{{
                  !valueMap.enterprisePortVessel
                    ? ""
                    : valueMap.enterprisePortVessel.label &&
                      valueMap.enterprisePortVessel.name
                }}</span>
              </div>
              <div v-else>
                <span style="font-weight: bolder; font-size: larger">{{
                  !valueMap.task_name ? "-" : valueMap.task_name
                }}</span>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row style="height: 50%">
          <vs-col vs-w="3" class="flex justify-start items-center">
            <div class="th">オーダー</div>
            <div class="td">
              <vs-chip
                class="pm-chip-square-radius"
                :color="
                  !(
                    valueMap.task_detail.order_type &&
                    valueMap.task_detail.order_type.valueMap
                  )
                    ? '#4F4F4F'
                    : valueMap.task_detail.order_type.valueMap.id === '1'
                    ? '#5286ED'
                    : valueMap.task_detail.order_type.valueMap.id === '2'
                    ? '#A8309C'
                    : valueMap.task_detail.order_type.valueMap.id === '3'
                    ? '#34A118'
                    : valueMap.task_detail.order_type.valueMap.id === '5'
                    ? '#A8309C'
                    : valueMap.task_detail.order_type.valueMap.id === '6'
                    ? '#5286ED'
                    : '#4F4F4F'
                "
              >
                {{
                  valueMap &&
                  valueMap.task_detail.order_type.valueMap &&
                  valueMap.task_detail.order_type.valueMap.value
                    ? valueMap.task_detail.order_type.valueMap.value
                    : ""
                }}
              </vs-chip>
              <span class="pm-time-disp">
                {{ formattedTime(valueMap.task_detail.order_at.valueMap) }}
              </span>
            </div>
          </vs-col>
          <vs-col vs-w="3" class="flex justify-start items-center">
            <div class="th pm-secondary-th"><span>進捗</span></div>
            <div class="td">
              <vs-chip
                class="pm-chip-square-radius"
                :color="
                  colorProgressList.find(
                    (color) =>
                      color.id === valueMap.task_detail.progress.valueMap.id,
                  ).value
                "
              >
                {{ valueMap.task_detail.progress.valueMap.value }}
              </vs-chip>
              <span class="pm-time-disp">
                {{
                  formattedTimeForProgress(
                    valueMap.task_detail.progress_at.valueMap,
                  )
                }}
              </span>
            </div>
          </vs-col>
          <vs-col vs-w="3" class="flex justify-start items-center">
            <div class="th pm-secondary-th"><span>バース</span></div>
            <div class="td">
              <div
                :style="{
                  'padding-left': '0.4rem',
                  'border-left':
                    valueMap.task_detail.berth.valueMap &&
                    valueMap.task_detail.berth.valueMap.color
                      ? '4px solid #' +
                        valueMap.task_detail.berth.valueMap.color.color_hex
                      : '',
                }"
              >
                {{
                  valueMap.task_detail.berth.valueMap
                    ? valueMap.task_detail.berth.valueMap.name
                    : "-"
                }}
              </div>
            </div>
          </vs-col>
          <vs-col vs-w="3" class="flex justify-start items-center">
            <div class="th pm-secondary-th"><span>前泊地</span></div>
            <div class="td">
              {{
                (valueMap.task_detail.previous.valueMap &&
                  (valueMap.task_detail.previous.valueMap.port_name ||
                    (valueMap.task_detail.previous.valueMap.berth &&
                      valueMap.task_detail.previous.valueMap.berth.code))) ||
                "-"
              }}
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <hr style="margin: 1rem 0" />
    <vs-row vs-w="12" style="height: 5rem">
      <vs-col class="w-full">
        <vs-row style="height: 50%">
          <vs-col class="flex items-center th">
            <div class="th">注意</div>
            <div class="td">
              <span
                v-for="(caution, index) in valueMap.task_detail.caution_note
                  .valueMap.value"
                :key="index"
                style="margin-right: 1rem"
              >
                <vs-chip
                  :color="'#' + caution.tag.color.color_hex"
                  style="border-radius: 4px"
                >
                  <span class="td" style="font-weight: normal">{{
                    caution.tag.name
                  }}</span>
                </vs-chip>
              </span>
              <span
                v-if="
                  !valueMap.task_detail.caution_note.valueMap.value ||
                  valueMap.task_detail.caution_note.valueMap.value.length === 0
                "
              >
                -
              </span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row style="height: 50%">
          <vs-col class="flex items-center th">
            <div class="th">備考</div>
            <div class="td">
              <span>{{
                valueMap.task_detail.required_note.valueMap.value || "-"
              }}</span>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <hr style="margin: 1rem 0" />
    <vs-row vs-w="12">
      <vs-col
        vs-w="6"
        vs-justify="flex-start"
        vs-align="flex-start"
        id="pm-vessel-live-map-container-area"
        class="vs-con-loading__container"
      >
        <div id="pm-vessel-live-map-container"></div>
      </vs-col>
      <vs-col
        vs-w="6"
        vs-justify="flex-start"
        vs-align="flex-start"
        style="padding: 0.4rem"
      >
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> 最終受信 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (getVesselLivePosition &&
                getVesselLivePosition.t &&
                formattedVesselPositionLastUpdated(getVesselLivePosition.t)) ||
              "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> 現在位置 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <div class="td pm-lat-long">
              <span
                v-if="
                  getVesselLivePosition &&
                  getVesselLivePosition.l &&
                  getVesselLivePosition.l._lat &&
                  getVesselLivePosition.l._long
                "
              >
                {{
                  getVesselLivePosition &&
                  getVesselLivePosition.l &&
                  getVesselLivePosition.l._lat | toGeoLabel
                }}
                /
                {{
                  getVesselLivePosition &&
                  getVesselLivePosition.l &&
                  getVesselLivePosition.l._long | toGeoLabel
                }}
              </span>
              <span v-else> - </span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> 針路 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (getVesselLivePosition && getVesselLivePosition.d + " °") || "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> 速力 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (getVesselLivePosition && getVesselLivePosition.v + " kn") || "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> 船首方位 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (getVesselLivePosition && getVesselLivePosition.h + " °") || "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> MMSI </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (valueMap.enterprisePortVessel &&
                valueMap.enterprisePortVessel.mmsi) ||
              "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> IMO </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (valueMap.enterprisePortVessel &&
                valueMap.enterprisePortVessel.imo) ||
              "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> コールサイン </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (valueMap.enterprisePortVessel &&
                valueMap.enterprisePortVessel.call_sign) ||
              "-"
            }}</span>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" class="pm-port-vessel-detail">
          <vs-col vs-w="4" class="flex items-center">
            <span class="th" style="padding-left: 1rem"> トン数 </span>
          </vs-col>
          <vs-col vs-w="8" class="flex items-center">
            <span class="td">{{
              (valueMap.enterprisePortVessel &&
                Math.floor(
                  valueMap.enterprisePortVessel.tonnage,
                ).toLocaleString() + " t") ||
              "-"
            }}</span>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <component :is="'style'" v-if="loading === false && !vesselLivePosition">
      #pm-vessel-live-map-container::after{ content:
      '船舶が見つかりませんでした'; font-size: 130%; color:white;
      background-color: #09151c; opacity: 0.8; z-index: 999; text-align: center;
      vertical-align: text-bottom; line-height: 18rem; position: absolute; top:
      0; right: 0; bottom: 0; left: 0; display:block }
    </component>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
const {
  mapActions: mapActionsOfVesselView,
  mapGetters: mapGettersOfVesselView,
} = createNamespacedHelpers("enterpriseVesselView");
const { mapState: mapStateOfPortMaster } =
  createNamespacedHelpers("portMaster");

const { mapActions, mapState } = createNamespacedHelpers(
  "portMasterDestinationWork",
);
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");

import Vue from "vue";
import { db } from "@/firebase/firebaseConfig";
import Mapbox from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { MAP_STYLE_DEFAULT } from "@/config/const";
import { LiveVesselMapLayer, LiveVesselMapSource } from "@/config/Map.js";
import moment from "moment-timezone";

// utils
import { WakeLineUtil } from "@/utils";

export default {
  props: {
    showPopup: { type: Boolean, required: true },
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { required: true },
  },
  data() {
    return {
      initialized: false,
      vesselId: null,
      vessel: null,
      wakes: [],
      //// mapbox
      map: null,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      mapStyle: MAP_STYLE_DEFAULT + "?optimize=false",
      defaultPosition: { zoom: 13 },
      center: [139.86448000000001, 35.54817666666667],
      firestoreUnsubscribes: [],
      vesselLivePosition: null,
      timerId: null,
      loading: true,
    };
  },
  watch: {
    async showPopup() {
      if (this.showPopup !== false) {
        this.onLoad();
      } else {
        this.onUnload();
      }
    },
    async vesselLivePosition(newPosition) {
      let vesselName =
        this.vessel.name_ja !== null ? this.vessel.name_ja : this.vessel.name;
      if (this.wakes.length === 0) {
        let payload = {
          vesselId: this.vesselId,
          vesselName: vesselName,
        };
        this.wakes = await this.fetchWakeLine(payload);
      }
      let payload = {
        vesselId: this.vesselId,
        position: newPosition,
        ais: this.aisInfo,
      };
      let res = await this.crateLiveVesselsFeatureCollections(payload);
      this.setSources(res);

      const position = await this.getLastPosition(this.vesselId);
      let lastPosition = position ? position.data : null;

      let wakeDate = {
        lat: lastPosition ? lastPosition.latitude : newPosition.l.latitude,
        lon: lastPosition ? lastPosition.longitude : newPosition.l.longitude,
        v: newPosition.v,
        t: newPosition.t,
        opacity: 0.9,
        color: WakeLineUtil.getVelocityColor(newPosition.v),
        localDate: moment.utc(newPosition.t).local().format("YYYY/MM/DD HH:mm"),
        vesselName: vesselName,
      };

      this.wakes.push(wakeDate);
      await this.setWakeLineSources();

      if (!this.initialized) {
        let coordinates = {
          center: [newPosition.l._long, newPosition.l._lat],
        };
        this.map.jumpTo(coordinates);
        this.map.zoomTo(12);
        this.initialized = true;
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: (state) => state.masterMap,
    }),
    ...mapGetters({
      vesselPositionCollection: "vesselPositionCollection",
    }),
    ...mapStateOfPortMaster({
      selectedPort: (state) => state.selectedPort,
    }),
    ...mapGettersOfVesselView(["getVesselLivePosition"]),
    masterOrderTypeList() {
      return this.masterMap["order_type"];
    },
    masterPortsList() {
      return this.masterMap["ports"];
    },
    masterProgressList() {
      return this.masterMap["progress"];
    },
    colorProgressList() {
      return this.masterMap["progress_colors"];
    },
  },
  methods: {
    ...mapActionsOfVesselView([
      "setVesselLivePosition",
      "setVesselLiveAisInfo",
      "crateLiveVesselsFeatureCollections",
      "fetchWakeLine",
      "crateWakeLineFeatureCollection",
      "getLastVesselPosition",
      "setVesselPositionExpired10min",
    ]),
    ...mapActions(["searchVessel"]),
    ...mapActionsOfLiveMap(["getLastPosition"]),
    initMapbox() {
      Mapbox.accessToken = this.accessToken;
      this.map = new Mapbox.Map({
        container: "pm-vessel-live-map-container",
        style: this.mapStyle,
        center: this.center,
        zoom: this.defaultPosition.zoom,
      });
      this.map.setMaxZoom(18);

      let navZoom = new Mapbox.NavigationControl({
        showZoom: true,
        showCompass: false,
        visualizePitch: true,
      });
      this.map.addControl(navZoom);
      navZoom._container.parentNode.className = "mapboxgl-ctrl-nav-zoom";

      let scale = new Mapbox.ScaleControl({
        maxWidth: 80,
        unit: "imperial",
      });
      this.map.addControl(scale);
      scale.setUnit("metric");

      // Mapboxのライフサイクルイベントセット
      this.map.on("style.load", this.mapStyleLoad);
    },
    async mapStyleLoad(_a, _b) {
      this.unsubscribeFireStore();
      this.createPulsing(this.map);
      this.addSources();
      this.addLayers();
      await this.setLiveData();
      setTimeout(() => {
        this.$vs.loading.close(
          "#pm-vessel-live-map-container-area > .con-vs-loading",
        );
        this.loading = false;
      }, 2000);
    },

    addLayers() {
      this.map.addImage("pulsing", this.pulsing, { pixelRatio: 2 });
      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselPulsingLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselPulsingSource.id,
        maxzoom: 15,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "pulsing",
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselWakeLineLayer.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselWakeLineSource.id,
        paint: {
          "line-color": ["get", "color"],
          "line-width": 2.0,
          "line-opacity": ["get", "opacity"],
          "line-dasharray": [1, 1],
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselWakeLineLayerForClickEvent.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        paint: {
          "line-width": 20.0,
          "line-opacity": 0.0,
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselVectorLayer.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselVectorSource.id,
        minzoom: 8,
        maxzoom: 24,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#DA514B",
          "line-width": 2.0,
          "line-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselPolygonLayer.id,
        type: "fill",
        source: LiveVesselMapSource.LiveVesselPolygonSource.id,
        minzoom: 14,
        maxzoom: 24,
        paint: {
          "fill-color": {
            type: "identity",
            property: "co",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselSymbolLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        minzoom: 1,
        maxzoom: 14,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image": "{i}",
          "icon-rotate": {
            type: "identity",
            property: "r",
          },
        },
        paint: {
          "icon-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselSymbolWithoutSizeLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        minzoom: 14,
        filter: ["all", ["==", ["number", ["get", "is_size"]], 0]],
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image": "{i}",
          "icon-rotate": {
            type: "identity",
            property: "r",
          },
        },
        paint: {
          "icon-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselTextLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        layout: {
          "text-field": "{n}",
          "text-anchor": "top",
          "text-size": 14,
          "text-line-height": 1.2,
          "text-offset": [0, 1.1],
          "text-allow-overlap": true,
          "text-ignore-placement": true,
        },
        paint: {
          "text-color": "#54B1FC",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });
    },

    addSources() {
      this.map.addSource(LiveVesselMapSource.LiveVesselPulsingSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselWakeLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(
        LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        },
      );

      this.map.addSource(LiveVesselMapSource.LiveVesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselWithoutSizeSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselSymbolSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
    },

    setSources(featureCollections) {
      const pulsingSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselPulsingSource.id,
      );
      if (pulsingSource != null) {
        pulsingSource.setData(featureCollections.symbolFeatureCollection);
      }

      const pointSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselSymbolSource.id,
      );
      if (pointSource != null) {
        pointSource.setData(featureCollections.symbolFeatureCollection);
      }

      const polygonSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselPolygonSource.id,
      );
      if (polygonSource != null) {
        polygonSource.setData(featureCollections.polygonFeatureCollection);
      }

      const vectorSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselVectorSource.id,
      );
      if (vectorSource != null) {
        vectorSource.setData(featureCollections.polygonFeatureCollection);
      }
    },

    unsubscribeFireStore() {
      if (this.firestoreUnsubscribes.length !== 0) {
        this.firestoreUnsubscribes.forEach((unsubscribe) => unsubscribe());
        this.firestoreUnsubscribes = [];
      }
    },

    async setWakeLineSources() {
      if (this.wakes.length >= 2) {
        let featureCollection = await this.crateWakeLineFeatureCollection(
          this.wakes,
        );
        const source = this.map.getSource(
          LiveVesselMapSource.LiveVesselWakeLineSource.id,
        );
        if (source != null) {
          source.setData(featureCollection);
        }
        const sourceForClickEvent = this.map.getSource(
          LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        );
        if (sourceForClickEvent != null) {
          sourceForClickEvent.setData(featureCollection);
        }
      }
    },

    async setLiveData() {
      if (this.vesselId && this.vessel) {
        await this.subscribeAisInfo();
      }
    },

    async subscribeVesselPosition() {
      let unsubscribe = await db
        .collection(this.vesselPositionCollection)
        .doc(this.vesselId)
        .onSnapshot(
          (doc) => {
            if (doc.data() !== undefined) {
              let target = moment(doc.data().t);
              if (moment().diff(target, "minutes") > 10) {
                this.vesselLivePosition = doc.data();
                this.setVesselLivePosition(doc.data());
              } else {
                this.vesselLivePosition = doc.data();
                this.setVesselLivePosition(doc.data());
              }
              this.hasLiveMapError = false;
            } else {
              this.$vs.loading.close(
                "#vessel-live-map-container > .con-vs-loading",
              );
              this.hasLiveMapError = true;
            }
          },
          function (error) {
            Vue.$log.error(error);
          },
        );

      this.firestoreUnsubscribes.push(unsubscribe);
    },

    async subscribeAisInfo() {
      let unsubscribe = await db
        .collection("vessel_info")
        .doc(this.vesselId)
        .onSnapshot(
          (doc) => {
            if (doc.data() !== undefined) {
              this.aisInfo = doc.data();
              if (!this.initialized || this.isStyleChange) {
                this.subscribeVesselPosition();
                this.isStyleChange = false;
              }
            }
          },
          function (error) {
            Vue.$log.error(error);
          },
        );
      this.firestoreUnsubscribes.push(unsubscribe);
    },

    createPulsing(map) {
      let size = 100;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          let duration = 2000;
          let t = (performance.now() % duration) / duration;

          let radius = (size / 2) * 0.3;
          let outerRadius = (size / 2) * 0.7 * t + radius;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2,
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          map.triggerRepaint();

          return true;
        },
      };
    },

    formattedTime(dateValue) {
      if (!dateValue || !dateValue.value) {
        return "";
      }
      return moment(dateValue.value).local().format("HH:mm");
    },
    formattedTimeForProgress(dateValue) {
      if (
        !dateValue ||
        !dateValue.value ||
        !dateValue.progress ||
        !dateValue.value[dateValue.progress]
      ) {
        return "";
      }
      return moment(dateValue.value[dateValue.progress].seconds * 1000)
        .local()
        .format("HH:mm");
    },
    formattedVesselPositionLastUpdated(t) {
      return moment(t).format("YYYY-MM-DD-HH:mm:ss");
    },
    async onLoad() {
      this.loading = true;
      this.vesselLivePosition = null;
      this.$vs.loading({
        container: "#pm-vessel-live-map-container-area",
        scale: 0.6,
      });

      this.initialized = false;
      const vessel = !this.valueMap.enterprisePortVessel
        ? null
        : await this.searchVessel({
            mmsi: this.valueMap.enterprisePortVessel.mmsi,
            imo: this.valueMap.enterprisePortVessel.imo,
            call_sign: this.valueMap.enterprisePortVessel.call_sign,
          });
      this.vesselId = vessel ? vessel.id : null;
      this.vessel = vessel ? vessel : null;
      const portInfo = this.masterPortsList.find(
        (x) => x.id === this.selectedPort.id,
      );
      if (portInfo) {
        this.center = [portInfo.port.longitude, portInfo.port.latitude];
      }
      this.$nextTick(() => {
        this.initMapbox();
      });
    },
    onUnload() {
      this.wakes = [];
      this.unsubscribeFireStore();
      if (this.unSubscribeStore) {
        this.unSubscribeStore();
      }
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      this.setVesselLivePosition(null);

      this.map = null;

      let oldChildElement = document.getElementById(
        "pm-vessel-live-map-container",
      );

      if (oldChildElement) {
        //親要素内の子要素を削除
        oldChildElement.innerHTML = "";
      }
    },
  },
  async mounted() {
    this.onLoad();
  },
  beforeDestroy() {
    this.onUnload();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.th {
  min-width: 4rem;
  font-size: 90%;
  font-weight: bold;
  margin-left: 0.2rem;
  margin-right: 0.5rem;
}
.td {
  font-size: 120%;
  display: flex;
  align-items: center;
}
.pm-secondary-th {
  display: flex;
  justify-content: flex-end;
  span {
    padding-right: 0.2rem;
  }
}
.pm-time-disp {
  margin-left: 0.1rem;
  font-size: 140%;
}
.pm-lat-long {
  white-space: nowrap;
  word-break: keeep-all;
}
.pm-chip-square-radius {
  border-radius: 0.2rem;
  min-width: 4rem;
  font-size: 56%;
  height: 2rem;
}
.pm-port-vessel-detail {
  height: 2.4rem;
}

#pm-vessel-live-map-container {
  width: 100%;
  height: 20rem;
  html,
  body {
    overflow: hidden;
  }

  .mapboxgl-ctrl-nav-zoom {
    top: 10px;
    left: calc(100% - 40px);
    position: absolute;
    pointer-events: none;
    z-index: 2;
  }

  .mapboxgl-popup-content {
    padding: 5px 10px 10px 10px;
    border-radius: 10px;
  }

  .vs-sidebar {
    max-width: 320px;
  }
}
</style>
